import { Link } from 'react-router-dom';
import type { Episode } from '@/types/content';

interface EpisodeCardProps {
  episode: Episode;
}

export default function EpisodeCard({ episode }: EpisodeCardProps) {
  return (
    <Link
      to={`/episode/${episode.id}`}
      className="group block rounded-lg overflow-hidden border border-background-200 bg-background-50 hover:border-primary-300 transition-colors"
    >
      <div className="relative w-full aspect-video overflow-hidden bg-background-200">
        <img
          src={episode.cover}
          alt={`女友的妈妈 第${episode.number}集 ${episode.title} 剧照cover`}
          title={`女友的妈妈 第${episode.number}集 ${episode.title} 剧集剧情`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-950/80 text-background-50 text-[11px] font-medium">
          第{String(episode.number).padStart(2, '0')}集
        </span>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1">
          {episode.title}
        </h3>
        <p className="flex items-center gap-1 text-xs text-foreground-500 mt-1.5">
          <i className="ri-calendar-line"></i>
          {episode.airDate}
          <span className="text-foreground-300">·</span>
          {episode.duration}
        </p>
        <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mt-2 line-clamp-2">
          {episode.synopsis}
        </p>
      </div>
    </Link>
  );
}